import { ComponentType, SVGProps } from 'react';

import BtcIcon from '@/assets/icons/coin/btc.svg';
import EthIcon from '@/assets/icons/coin/eth.svg';
import SolIcon from '@/assets/icons/coin/sol.svg';
import XrpIcon from '@/assets/icons/coin/xrp.svg';
import { normalizeTokenSymbol } from '@/lib/utils/pools';

export function getPoolIcon(
  tokenSymbol: string
): ComponentType<SVGProps<SVGSVGElement>> {
  const normalized = normalizeTokenSymbol(tokenSymbol);
  const iconMap: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
    btc: BtcIcon,
    eth: EthIcon,
    sol: SolIcon,
    xrp: XrpIcon
  };
  return iconMap[normalized] || BtcIcon;
}
